import React from 'react';
import PropTypes from 'prop-types';

import Accordion from '@stubhub/react-accordion';
import FormattedLink from '@stubhub/react-formatted-link';

/**
 * A list of items, support mutil depth
 */
class NavMenuOptionList extends React.Component {
  handleDocumentClick = (e) => {
    if (this.rootNode?.parentNode?.parentNode?.parentNode?.contains(e.target)) {
      const {onClickOutside} = this.props;
      onClickOutside && onClickOutside.call(this);
    }
  };

  componentDidMount() {
    const {nested} = this.props;
    // We only need to attach listener for the topmost instance
    if (!nested && typeof document !== 'undefined') {
      document.addEventListener('click', this.handleDocumentClick);
      document.addEventListener('mouseout', this.handleDocumentClick);
    }
  }

  componentWillUnmount() {
    const {nested} = this.props;
    if (nested && typeof document !== 'undefined') {
      document.removeEventListener('click', this.handleDocumentClick);
      document.removeEventListener('mouseout', this.handleDocumentClick);
    }
  }

  render() {
    const {items = [], onOptionClick} = this.props;
    const accordionItems = items.map((item) => {
      const className = `mh__nav-menu-option option__${item.id}`;
      // Override heading element from being wrapped with <a> tag
      if (item.id === 'have-questions') {
        item.type = 'string';
      }

      return {
        id: item.id,
        head:
          item.type === 'link' ? (
            item.noFormat ? (
              <a className={className} href={item.href} data-item-id={item.id} onClick={onOptionClick}>
                {item.label}
              </a>
            ) : (
              <FormattedLink className={className} href={item.href} data-item-id={item.id} onClick={onOptionClick}>
                {item.label}
              </FormattedLink>
            )
          ) : (
            <div id={item.id} className={className} data-item-id={item.id}>
              {item.label}
            </div>
          ),
        body: item.items ? (
          <div className="mh__nav-menu__sub-options">
            <NavMenuOptionList items={item.items} onOptionClick={onOptionClick} nested />
          </div>
        ) : null,
      };
    });

    return (
      <div ref={(node) => (this.rootNode = node)}>{accordionItems.length && <Accordion items={accordionItems} />}</div>
    );
  }
}

NavMenuOptionList.propTypes = {
  /** List of items to display */
  items: PropTypes.array.isRequired,

  /** Callback function when an option is clicked */
  onOptionClick: PropTypes.func,

  /** Callback function when clicked outside of the list */
  onClickOutside: PropTypes.func,

  /** Flag to indicate if this is a nested list */
  nested: PropTypes.bool,
};

export default NavMenuOptionList;
